<div class="container">
  <div class="form-wrapper" [class.disabled]="control.disabled">
    @if (label) {
      <ion-label class="ion-text-start">
        {{ label }}
      </ion-label>
    }
    <div class="wrapper"
      [class.error]="showError && control?.errors && control?.touched"
      (click)="!control.disabled && setPickerOpen(true)">
      @if (control.value) {
        <p>{{ control.value | date:'dd/MM/yyyy' }}</p>
      } @else {
        <p class="placeholder">{{ placeholder }}</p>
      }
      <div class="icon-container">
        @if (showClearButton && control.value) {
          <c-icon [icon]="faXmark" (action)="$event.stopPropagation(); clearControlValue();" />
        }
        <c-icon [icon]="faCalendar" />
      </div>
    </div>
  </div>
  @if (showError && control?.errors && control?.touched) {
    <div class="error-wrapper">
      <c-validation-error [validationMessages]="control.errors" [controlValue]="control.value" />
    </div>
  }
</div>

<ion-modal
  [isOpen]="isPickerOpen"
  (willPresent)="willPresentHandler()"
  (didPresent)="didPresentHandler()"
  (didDismiss)="setPickerOpen(false)"
  [breakpoints]="[0, 1]"
  [initialBreakpoint]="1"
  [handle]="false"
  class="auto-height-modal">
  <ng-template>
    <mbsc-datepicker
      display="inline"
      returnFormat="jsdate"
      [controls]="['calendar']"
      [firstDay]="1"
      [touchUi]="true"
      [min]="minDate"
      [max]="maxDate"
      [locale]="localeAll[currentLocale()]"
      [(ngModel)]="datePickerValue">
    </mbsc-datepicker>
    <div class="datepicker-buttons">
      <c-button
        type="ghost"
        [fullWidth]="false"
        (action)="cancelDatePicker()"
        data-test-id="datepicker.cancel-button">
        {{ 'common.cancel' | transloco }}
      </c-button>
      <div>
        @if (showClearButton) {
          <c-button type="ghost" [fullWidth]="false" (action)="clearSelectedDate()" data-test-id="datepicker.delete-button">
            {{ 'common.delete' | transloco }}
          </c-button>
        }
        <c-button type="ghost" [fullWidth]="false" (action)="confirmSelectedDate()" data-test-id="datepicker.ok-button">
          {{ 'common.ok' | transloco }}
        </c-button>
      </div>
    </div>
  </ng-template>
</ion-modal>
